import pl from "@locales/cooperation_settings/pl.json";
import en from "@locales/cooperation_settings/en.json";
export default {
  pl: pl,
  en: en,
};
